(function () {
  'use strict';

  var CUSTOM_SIZE = 'Custom Size';

  function normalizeSize(value) {
    if (!value) return '';
    return String(value).replace(/\s+/g, '').toUpperCase();
  }

  function sizeMatches(row, selected) {
    if (!selected) return false;
    var norm = normalizeSize(selected);
    var candidates = [
      row.getAttribute('data-size'),
      row.getAttribute('data-size-alt'),
      row.getAttribute('data-size-num'),
    ];
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (!c) continue;
      if (normalizeSize(c) === norm) return true;
      if (normalizeSize('US' + c) === norm) return true;
      if (normalizeSize('US ' + c) === norm) return true;
    }
    return false;
  }

  function getSelectedSize(root) {
    var scope =
      root.closest('variant-radios, combie-variants, .product-option') ||
      document;
    var checked = scope.querySelector(
      'fieldset.product-styless-size input.product-form__radio:checked, fieldset[class*="size"] input.product-form__radio:checked'
    );
    if (checked) return checked.value;

    var sizeInputs = scope.querySelectorAll(
      'input.product-form__radio[name="Size"]:checked, input.product-form__radio[name="size"]:checked'
    );
    if (sizeInputs.length) return sizeInputs[0].value;

    var jsonEl = root.querySelector('[data-hs-selected-size]');
    if (jsonEl) {
      try {
        return JSON.parse(jsonEl.textContent);
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  function updatePreview(root) {
    var selected = getSelectedSize(root);
    var isCustom =
      selected && normalizeSize(selected) === normalizeSize(CUSTOM_SIZE);

    if (!selected || isCustom) {
      root.hidden = true;
      return;
    }

    var tables = root.querySelectorAll('[data-hs-unit]');
    var anyMatch = false;

    tables.forEach(function (table) {
      var rows = Array.from(table.querySelectorAll('tbody tr'));
      var matchIndex = -1;

      rows.forEach(function (row, index) {
        row.hidden = true;
        row.classList.remove('is-selected');
        if (sizeMatches(row, selected)) {
          matchIndex = index;
          row.classList.add('is-selected');
        }
      });

      if (matchIndex < 0) return;

      anyMatch = true;
      var start =
        matchIndex === 0
          ? 0
          : matchIndex === rows.length - 1
            ? Math.max(0, matchIndex - 2)
            : matchIndex - 1;

      for (var i = 0; i < 3 && start + i < rows.length; i++) {
        rows[start + i].hidden = false;
      }
    });

    root.hidden = !anyMatch;
  }

  function setUnit(root, unit) {
    var switchBtn = root.querySelector('[data-hs-unit-switch]');
    var tables = root.querySelectorAll('[data-hs-unit]');
    tables.forEach(function (table) {
      var isActive = table.getAttribute('data-hs-unit') === unit;
      table.hidden = !isActive;
      table.classList.toggle('is-active', isActive);
    });
    if (switchBtn) {
      switchBtn.classList.toggle('is-inch', unit === 'inch');
      switchBtn.classList.toggle('is-cm', unit === 'cm');
      switchBtn.setAttribute('aria-pressed', unit === 'cm' ? 'true' : 'false');
    }
  }

  function bindPreview(root) {
    if (root.dataset.hsBound === '1') return;
    root.dataset.hsBound = '1';

    var scope =
      root.closest('variant-radios, combie-variants, .product-option') ||
      document;

    scope.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || target.type !== 'radio') return;
      var name = (target.name || '').toLowerCase();
      if (name !== 'size' && !target.closest('fieldset.product-styless-size')) {
        return;
      }
      updatePreview(root);
    });

    var switchBtn = root.querySelector('[data-hs-unit-switch]');
    if (switchBtn) {
      switchBtn.addEventListener('click', function () {
        var next = switchBtn.classList.contains('is-cm') ? 'inch' : 'cm';
        setUnit(root, next);
      });
    }

    setUnit(root, 'inch');
    updatePreview(root);
  }

  function init() {
    if (!document.querySelector('.product-details.product-horizontal-strip')) {
      return;
    }
    document.querySelectorAll('[data-hs-size-preview]').forEach(bindPreview);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
